import React, { useState } from "react";
import { FC_FLOW_PRE_URL } from "../../../../../services/api";
import { eventTrack } from "src/components/GoogleTagManager";
import Checkbox from "src/components/Checkbox";
import ReactModal from "react-modal";
import * as S from "./styles";

function Footer({ terms, modalOpen, cupons, disabled }) {
  const [checked, setChecked] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <S.Container blur={modalOpen}>
        <S.Terms isChecked={checked}>
          <Checkbox
            id="check-term"
            disabled={modalOpen}
            onChange={() => {
              setChecked(!checked);
              eventTrack(
                "veloe:institucional",
                "interacao:checkbox",
                "check-term:" + String(!checked)
              );
            }}
            className="termoAceite"
          />
          <label htmlFor="check-term">
            Estou ciente que, ao prosseguir, aceito o{" "}
            <b
              onClick={(e) => {
                e.preventDefault();
                !disabled && setOpenModal(true);
              }}
            >
              regulamento
            </b>{" "}
            da campanha.
          </label>
        </S.Terms>
        <div className="botoesCupons">
          <S.Link
            disabled={!checked}
            href={
              disabled ? "" : `${FC_FLOW_PRE_URL}?origem=lp&codigo=${cupons[0]}`
            }
          >
            <S.ContainerCTA>
              <S.CustomButton
                label="Peça já"
                backgroundColor="#00FF5F"
                color="#1E3C3C"
                disabled={!checked}
                onClick={() =>
                  eventTrack(
                    "veloe:institucional",
                    "clique:botao",
                    "planos:peca-ja"
                  )
                }
              >
                Peça já
              </S.CustomButton>
            </S.ContainerCTA>
          </S.Link>
        </div>
      </S.Container>
      <ReactModal isOpen={openModal} onRequestClose={() => setOpenModal(false)}>
        <S.ModalHeader>
          <S.CloseButton
            src="/tagnext/assets/icon-close.png"
            onClick={() => setOpenModal(false)}
          />
        </S.ModalHeader>
        <div>
          {terms.content &&
            terms.content?.map((term) => (
              <S.Line key={term}>
                {term.content.map(({ value, marks }) => {
                  const className = !!marks
                    ? marks.map((mark) => mark.type).join(" ")
                    : "";
                  return (
                    <S.TextBlock
                      key={marks}
                      className={className}
                      dangerouslySetInnerHTML={{ __html: value }}
                    ></S.TextBlock>
                  );
                })}
              </S.Line>
            ))}
        </div>
      </ReactModal>
    </>
  );
}

export default Footer;
